export default {
    type: 'numeric',
    format: {
        decimals: 0,
        min: 0,
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Play Duration',
        category: ['User', 'Plays'],
        description: 'Duration in minutes of a play.',
        summarise: {
            prefix: 'Plays',
            postfix: 'in duration'
        },
        unit: 'minute'
    },
    rules: {
        linked: [],
        legacy: ['play.duration']
    }
}